export default "__VITE_ASSET__Dm6jy4YH__"